var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app auth-page",style:(_vm.authStyle),attrs:{"id":"auth"}},[_c('div',{staticClass:"container",staticStyle:{"padding-top":"120px"}},[(_vm.loading)?_c('loader'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }